var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotiSentMsg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotiSentMsg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotiSentMsg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    fill: "#11AB96",
    cx: 13,
    cy: 13,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,8.67586 L21,15.8638 C21,16.78962 20.2643333,17.54 19.357,17.54 L12.3333333,17.54 L9,21.28 L9,17.54 L6.643,17.54 C5.73566667,17.54 5,16.78962 5,15.86414 L5,8.6762 C5,7.75038 5.73566667,7 6.643,7 L19.3566667,7 C20.2643333,7 21,7.75038 21,8.67586 Z M12.0930233,11.2 C12.2859302,11.2 12.4418605,10.91776 12.4418605,10.57 C12.4418605,10.22224 12.2859302,9.94 12.0930233,9.94 L7.20930233,9.94 C7.01639535,9.94 6.86046512,10.22224 6.86046512,10.57 C6.86046512,10.91776 7.01639535,11.2 7.20930233,11.2 L12.0930233,11.2 Z M16.9198075,12.88 C17.1184796,12.88 17.2790698,12.59776 17.2790698,12.25 C17.2790698,11.90224 17.1184796,11.62 16.9198075,11.62 L7.21972735,11.62 C7.02105533,11.62 6.86046512,11.90224 6.86046512,12.25 C6.86046512,12.59776 7.02105533,12.88 7.21972735,12.88 L16.9198075,12.88 Z M16.9198075,14.98 C17.1184796,14.98 17.2790698,14.69776 17.2790698,14.35 C17.2790698,14.00224 17.1184796,13.72 16.9198075,13.72 L7.21972735,13.72 C7.02105533,13.72 6.86046512,14.00224 6.86046512,14.35 C6.86046512,14.69776 7.02105533,14.98 7.21972735,14.98 L16.9198075,14.98 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotiSentMsg);
export default __webpack_public_path__ + "static/media/icNotiSentMsg.b17b27cfbc8a39ff27adc1f68eb9f556.svg";
export { ForwardRef as ReactComponent };